<template>
        <div class="progress-bar">
            <div class="filled-bar"
                 :style="{ width: 100 - (progress * 100) + '%' }"
            >
            </div>

            <div class="percentage-text">
                 {{ percentageText }}
            </div>

        </div>
</template>
<script>
    export default {
        mounted: function(){
            window.addEventListener('scroll', this.handleScroll);
        },
        data: function(){
            return {
                progress: 1,
                totalReadingTime: this.calculateTimeBasedOnWords(),
                scrollHeight: document.documentElement.scrollHeight,
                clientHeight: document.documentElement.clientHeight
            }
        },
        methods:{
            handleScroll: function(){
                let bodyScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                const progress = 1 - (bodyScrollTop / (this.scrollHeight - this.clientHeight));

                if (progress > 1) {
                    this.progress = 1
                } else if (progress < 0) {
                    this.progress = 0
                } else {
                    this.progress = progress
                }
            },
            calculateTimeBasedOnWords: function(){
                let wordCount = document.getElementById('story-content').innerText.split(" ").length;
                return Math.floor(wordCount / 240)
            },
        },
        computed: {
            percentageText: function(){
                let minutesLeft = Math.ceil(((this.progress * 100) * this.totalReadingTime) / 100);
                let minuteText = (minutesLeft === 1) ? ' minuut lezen' : ' minuten lezen';
                return minutesLeft + minuteText;
            }
        },
    }
</script>
<style lang="scss" scoped>
    .progress-bar {
        top: 0;
        height: 50px;
        width: 100%;
        padding-top: 40px;
        background: #fff;
        border-bottom: 1px solid #fff;
        overflow: hidden;
    }

    .percentage-text {
        position: absolute;
        top: 20px;
        left: 50px;
        z-index: 2;
        font-size: 14px;
        transform: translate3d(-50%, -50%, 0);
    }

    .filled-bar {
        z-index: 2;
        height: 2px;
        width: 100%;
        background: #000;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/site/components/stories/progress-bar.vue